import React from 'react';
import './App.css';
import Header from './components/Header';
import { LanguageProvider } from './context/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <div className="app-container">
        <Header />
      </div>
    </LanguageProvider>
  );
}

export default App;
